import React, { useEffect, useLayoutEffect, useState } from 'react';
import { connect, useStore } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import useMedia from 'use-media';
import commonUtil from '../../../common/commonUtil';
import { apiKeyCheck } from '../../../const';
import { useRtoaster } from '../../../hooks/useRtoaster';
import image_complete from '../../../resources/icons/complete.svg';
import image_button from '../../../resources/icons/ico_reserve.svg';
import image_base from '../../../resources/image/HakoneGardenTerrace.jpg';
import common from '../../../resources/js/common/common';
import { Button } from '../../atoms/button';
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/hotel/membership_reserve_comp.css';


const EstheticReserveCompleteContainer = (props) => {
    const { 
        state,
        estheRsvInfo,
        setEstheRsvInfo
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const store = useStore();
    const history = useHistory();

    const [reserveComf, setReserveComf] = useState({})

    // rtoasterタグ生成
    const customParam = {
        "sisetucd": estheRsvInfo.shisetsuCd,
        "riyodat": estheRsvInfo.riyoDate,
        "menucd": estheRsvInfo.mainCourseList?.length ? estheRsvInfo.mainCourseList[0].courseCd : "",
        "jikan": estheRsvInfo.yoyakuTime,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        // let state = store.getState().login;
        // let apiKey = null;
        // if(Object.keys(state).length !== 0){   
        //     apiKey = state.apiKey;
        // }
        // if(apiKey === null){
        //     store.dispatch({ type: "CLEAR_STATE"});
        //     history.push("/reserve/login");
        // }
        // if(apiKey){
        // common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        // }
    })
    const afterApiKeyCheck = (res) => {
        // if(!res.data){
        //     console.log("バックからの戻り値false");
        //     store.dispatch({ type: "CLEAR_STATE"});
        //     history.push("/reserve/login");
        // }
    }

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        // common.versionCheck();
        window.scroll({ top: 0, behavior: 'smooth' })
        if (Object.keys(estheRsvInfo).length != 0) {
            setReserveComf({...estheRsvInfo});
        }
        setEstheRsvInfo({});
    }, []);

    // スマートコンシェルジュに戻るボタン押下時処理
    const onClickDecision = () =>{
        document.getElementById("topLink")?.click();
    }

    return (
        <div style={isWideTablet ? styles.topCancel : styles.top}>
            <div className={isWideTablet ? "membership_reserve_base2" : "membership_reserve_base"}>
                <div style={styles.complete}></div>
                <p className="membership_reserve_title">ご予約を承りました</p>
                {reserveComf.loginFlg ?
                    <p className={isWideTablet ? "membership_reserve_text2" : "membership_reserve_text"}>
                        ご利用いただき誠にありがとうございます。
                        <br />予約完了メールをお送りいたしましたので、{isWideTablet ? <br /> : null}内容をご確認ください。
                    </p>
                    :
                    <p className={isWideTablet ? "membership_reserve_text2" : "membership_reserve_text"}>
                        ご利用いただき誠にありがとうございます。<br />
                        {reserveComf.successSmsFlg ?
                            <>
                                予約完了ショートメッセージをお送りいたしましたので、{isWideTablet ? <br /> : null}内容をご確認ください。
                            </>
                            :
                            <>
                                予約完了ショートメッセージの送信に失敗しました。{isWideTablet ? <br /> : null}以下の予約内容をご確認ください。
                            </>
                        }
                    </p>
                }
                <div className='membership_reserveinfo_area'>
                    <div className='membership_reserveinfo_content'>
                        <div className='membership_reserveinfo_title'>
                            <div>ご予約内容</div>
                        </div>
                        <div className='membership_reserveinfo_sub'>
                            <div className='reserveInfoContentBlock'>
                                <div className='reservationContent lastContent'>
                                    <div className={isWideTablet ? null : 'reserveInfoTitleGray'}>予約番号</div>
                                    <div className='membership_reserveinfo_data2 membership_reserve_black'>{reserveComf.yoyakuNo}</div>
                                </div>
                            </div>
                            <div className='reserveInfoContentBlock '>
                                <div className='reservationContent lastContent'>
                                    <div className={isWideTablet ? null : 'reserveInfoTitleGray'}>館内施設名</div>
                                    <div className='membership_reserveinfo_data2 membership_reserve_black'>{reserveComf.shisetsuName + "\n" + reserveComf.estheticName}</div>
                                </div>
                            </div>
                            <div className='reserveInfoContentBlock '>
                                <div className='reservationContent lastContent'>
                                    <div className={isWideTablet ? null : 'reserveInfoTitleGray'}>ご利用日</div>
                                    <div className='membership_reserveinfo_data2 membership_reserve_black'>{reserveComf.riyoDate ? commonUtil.getStringFromDateJpnMembership(reserveComf.riyoDate) : ""}</div>
                                </div>
                            </div>
                            <div className='reserveInfoContentBlock '>
                                <div className='reservationContent lastContent'>
                                    <div className={isWideTablet ? null : 'reserveInfoTitleGray'}>時間</div>
                                    <div className='membership_reserveinfo_data2 membership_reserve_black'>{reserveComf.yoyakuTime ? commonUtil.getTimeStr(reserveComf.yoyakuTime, "hh:mm") : ""}</div>
                                </div>
                            </div>
                            <div className='reserveInfoContentBlock '>
                                <div className='reservationContent lastContent'>
                                    <div className={isWideTablet ? null : 'reserveInfoTitleGray'}>人数</div>
                                    <div className='membership_reserveinfo_data2 membership_reserve_black'>{reserveComf.riyoNinzu}人</div>
                                </div>
                            </div>
                            <div className={'reserveInfoContentBlock ' + (reserveComf?.optionCourseList?.length > 0 ? "" : "lastContent")}>
                                <div className={'reservationContent lastContent'}>
                                    <div className={isWideTablet ? null : 'reserveInfoTitleGray'}>メインメニュー</div>
                                    {reserveComf.mainCourseList ? reserveComf.mainCourseList.map((course) =>
                                        <div className={'membership_reserveinfo_data2 membership_reserve_black'}>{course.courseName}</div>
                                    ) : null}
                                </div>
                            </div>
                            {reserveComf?.optionCourseList?.length > 0 ?
                                <div className='reserveInfoContentBlock lastContent'>
                                    <div className='reservationContent lastContent'>
                                        <div className={isWideTablet ? null : 'reserveInfoTitleGray'}>オプションメニュー</div>
                                        <div className={'membership_reserveinfo_data3 membership_reserve_black'}>
                                            {reserveComf.optionCourseList.map((course, index) =>
                                                <div className={'importedReserveInfoWapper' + (index != reserveComf.optionCourseList.length - 1 ? ' str_padding' : '')}>
                                                    {course.courseName}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
                <div className='membership_btn_area'>
                    <Button buttonText="スマートコンシェルジュに戻る" className="membership_top_btn"  onClick={onClickDecision}/>
                </div>
                <a id='topLink' className='hiddenItem' href={reserveComf.estheticUrl ? reserveComf.estheticUrl : "/reserve/login"} />
            </div>
            <div className={isWideTablet ? "membership_reserve_footer2" : "membership_reserve_footer"} >
                <MembershipFooterContainer />
            </div>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        estheRsvInfo: state.estheRsvInfo
    };
};
const mapToDispatchToProps = (dispatch) => {
    return {
        setEstheRsvInfo: (item) => {
            dispatch({ type: "ESTHE_RSV_INFO", payload: { estheRsvInfo: item } })
        },
    };
}
export default connect(mapStateToProps, mapToDispatchToProps)(EstheticReserveCompleteContainer);

const styles = {
    topMobile: {
        width: "100%",
        paddingTop: "25px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (12.3rem + 75px))",
    },
    top: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // height: "calc(100vh - (9.8rem + 100px))",
    },
    topCancel: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (7.1rem + 100px))",
        height: "100%",
    },
    complete: {
        width: "50px",
        height: "50px",
        backgroundImage: `url(${image_complete})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        margin: "0px auto 10px",
    },

    box: {
        display: "inline-block",
        textAlign: "center",
        margin: "0px auto",
        width: "100%",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "25px",
    },
    deletebr: {
        display: "none",
    },
    deletebr2: {
        display: "block",
    },
    btn: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "60%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btn2: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "100%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btnImage: {
        width: "30px",
        height: "30px",
        backgroundImage: `url(${image_button})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        marginTop: "5px",
    },
    useBtn: {
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        display: "inline-block",
        border: "none"
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        marginLeft: "10%",
    },
    breadCrumbArrow: {
        marginRight: "16px",
        marginTop: "0px",
    },
    label: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "0.9rem",
        letterSpacing: "0.2rem"
    },
    label2: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: 12.6,
        letterSpacing: "0.2rem"
    },
    image: {
        width: 200,
        width: "40%",
        margin: "0 auto",
    },
    form: {
        width: "60%",
        margin: "0px auto 50px",
    },
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "45px auto 0px",
    },
}